import { render } from "./ProspectsView.vue?vue&type=template&id=1a8b6ffd&scoped=true"
import script from "./ProspectsView.vue?vue&type=script&lang=js"
export * from "./ProspectsView.vue?vue&type=script&lang=js"

import "./ProspectsView.vue?vue&type=style&index=0&id=1a8b6ffd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8b6ffd"]])

export default __exports__